import { css } from '@emotion/react';
import React from 'react';

import Divider from '@/src/shared/components/Divider';
import Heading from '@/src/shared/components/Heading';
import { colors } from '@/styles';

const styles = {
  headerSectionContainer: css`
    top: 7.5rem;
    background-color: ${colors.white};
    z-index: 1000;
  `,
};

function HeaderSection({ headerText }) {
  return (
    <div css={styles.headerSectionContainer} className="sticky">
      <Heading type={1} weight="bold" theme="primaryGray" size="lg">
        {headerText}
      </Heading>
      <Divider />
    </div>
  );
}

export default HeaderSection;
